import React from 'react'
import { connect } from 'react-redux'
import Driver from './Driver.js'
import { getCurrentDrivers } from '../selectors.js'
import './DriverList.css'

const DriverList = ({ drivers = [] }) => (
  <div className="DriverList">{drivers.map(renderDriver)}</div>
)

function renderDriver(driver) {
  return <Driver key={driver.id} {...driver} />
}

const mapStateToProps = state => ({
  drivers: getCurrentDrivers(state),
})

export default connect(mapStateToProps)(DriverList)



// WEBPACK FOOTER //
// ./src/components/DriverList.js